import { render, staticRenderFns } from "./Informes.vue?vue&type=template&id=b624c0de&"
import script from "./Informes.vue?vue&type=script&lang=ts&"
export * from "./Informes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b624c0de', component.options)
    } else {
      api.reload('b624c0de', component.options)
    }
    module.hot.accept("./Informes.vue?vue&type=template&id=b624c0de&", function () {
      api.rerender('b624c0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/Informes.vue"
export default component.exports